// extracted by mini-css-extract-plugin
export default {"section":"styles_section__vUfb6","img":"styles_img__bWrve","heading":"styles_heading__IHbCR","para":"styles_para__Oc0K0"};